export default {
  menu: {},
};
